module.exports = __webpack_public_path__ + "static/media/fastbite-app_2screen.5814d7ee.png";